import { toNonNullableArray } from "@nx-superprep/utils"
import { IStepOption } from "ngx-ui-tour-md-menu"

export enum Tours {
  first_signup = 'first-signup',
  first_post_session = 'first-post-session',
  first_lesson_complete = 'first-lesson-complete',
  first_plan_complete = 'first-plan-complete',
  plan_complete_add = 'plan-complete-add',
}

export const allTours = [Tours.first_signup, Tours.first_post_session, Tours.first_lesson_complete, Tours.first_plan_complete, Tours.plan_complete_add]
export function getTours(tours = allTours) { return tours.map((tour) => ({ id: tour, name: tour.toString() })) }

export interface StepOption extends IStepOption {
  icon?: string
  iconSize?: string
  image?: string
  imageWidth?: string
}
// Tour steps

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getTourSteps(tours: Tours|Tours[], state: unknown = {}) {
  const _result: StepOption[] = []
  toNonNullableArray(tours).forEach((value) => {
    switch (value) {
      case Tours.first_signup: _result.push(...[
        {
          anchorId: 'anchor.lessons-list.1',
          content: 'Let\'s get started with your first unit! Tap to begin.',
          nextBtnTitle: 'Got it',
          endBtnTitle: 'Got it',
          prevStep: undefined,
          showProgress: false,
          isAsync: true,
          asyncStepTimeout: 15000,
          isOptional: true
        },
      ]); break
      case Tours.first_lesson_complete: _result.push(...[
        {
          anchorId: 'anchor.centered.image',
          stepDimensions: { minWidth: '30%' },
          title: 'Great job on completing your first session!',
          content: 'Consistency is key to learning, and we\'re here to help. See you tomorrow!',
          backdropConfig: { offset: 0, backgroundColor: 'rgb(0,0,0,0.5' },
          showArrow: false,
          icon: '/assets/favicons/favicon-32x32.png',
          iconSize: '24',
          image: '/assets/img/onboarding/first_session.svg',
          imageWidth: '218px',
          showProgress: false,
          nextBtnTitle: 'Next',
        },
      ]); break
      case Tours.first_post_session: _result.push(...[
        {
          anchorId: 'anchor.status.today',
          content: 'Here is the percentage of today\'s session you\'ve completed',
          showProgress: false,
          nextBtnTitle: 'Next',
          stepDimensions: { minWidth: '328px' },
        },
        {
          anchorId: "anchor.status.toggle",
          content: 'Tap here to view you overall unit progress',
          showProgress: false,
          nextBtnTitle: 'Next',
          stepDimensions: { minWidth: '328px' },
          isOptional: true
        },
        {
          anchorId: 'anchor.status.overall',
          content: 'Here is your overall unit progress',
          showProgress: false,
          nextBtnTitle: 'Got it',
          stepDimensions: { minWidth: '328px' },
          isOptional: true
        },
        {
          anchorId: 'anchor.header.performance',
          content: 'Tap here to track your study progress and performance',
          showProgress: false,
          nextBtnTitle: 'Got it',
          endBtnTitle: 'Got it',
          stepDimensions: { minWidth: '328px' },
          isOptional: true
        },
      ]); break
      case Tours.plan_complete_add: _result.push(...[
        {
          anchorId: 'anchor.centered.icon',
          content: 'Want to add another unit?',
          backdropConfig: { offset: 0, backgroundColor: 'rgb(0,0,0,0.5' },
          showArrow: false,
          icon: '/assets/favicons/favicon-32x32.png',
          iconSize: '24',
          image: '/assets/img/onboarding/add_circle.svg',
          imageWidth: '24px',
          showProgress: false,
          nextBtnTitle: 'Go to Explore',
        },
      ]); break
      case Tours.first_plan_complete: _result.push(...[
        {
          anchorId: 'anchor.lessons-list.1',
          content: 'Come back tomorrow! Spaced repetition boosts memory. Daily visits are key!',
          endBtnTitle: 'Got it',
          stepDimensions: { minWidth: '428px' },
          showProgress: false,
        },
      ]); break
    }
  })
  return _result
}
